import { axiosInstance } from '../api';

export default function(request) {
    return axiosInstance.post(`/api/studyreview/reject`, request);
}